import { render, staticRenderFns } from "./PreferredDepartment.vue?vue&type=template&id=2d0113a8"
import script from "./PreferredDepartment.vue?vue&type=script&lang=js"
export * from "./PreferredDepartment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports